import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { convertMdxToMd } from "../../../lib/convertMdx";
import geoConsoleUserGuideFile from "../../../assets/markDownFiles/consoleuserguide.md";

const GeoConsoleUserGuide = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (typeof geoConsoleUserGuideFile === "string" && geoConsoleUserGuideFile.startsWith("/static")) {
      fetch(geoConsoleUserGuideFile)
        .then((res) => res.text())
        .then((raw) => setContent(convertMdxToMd(raw)));
    } else {
      setContent(convertMdxToMd(geoConsoleUserGuideFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        Get Started
      </Typography>
      {content ? (
        <MarkdownRenderer content={content} />
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default GeoConsoleUserGuide;
